<template>
  <mu-appbar class="bgClass"  titleClass="appbarTitle">
    <mu-text-field style="margin:0px 20px 0 30px;" :underlineShow="false" slot="left" :hintText="hintDesc" hintTextClass="textField" inputClass="input-style" v-model="search.keyword"/>
    <mu-raised-button class="btnSearchClass" color="#0a81e9" label="搜索" slot="left" @click="searchKeyword" />

    <div v-if="showCount" class="training-wrapper">
      <div class="training-content">
        <div class="training-title">您有一个正在进行中的训练</div>
        <div class="training-name">患者：<span>{{trainName}}</span></div>
        <div class="training-time">时间：<span>{{trainTime}}</span></div>
      </div>
      <div class="icon-wrapper" @click="toTrain"><mu-icon value="keyboard_arrow_right" class="toTrain-icon" :size="50"/></div>
    </div>
    <mu-raised-button v-if="showNew" class="btnNewbuild" :label="labelFlag" slot="right" primary  @click="buildNewOrder" />
  </mu-appbar>
</template>

<script>
export default{
  props:["flag", "keyword"],
  data(){
    return{
      showNew: true,
      search: {
        keyword: this.keyword
      },
      showModal: false,

      /* 训练次数相关状态 */
      showCount:false,
      trainName:"刘玄武",//正在训练的患者的名字
      trainTime:"2018-01-05",
    }
  },
  computed:{
    labelFlag:function(){
      if(this.flag == 1){
        return "新建档案"
      } else if(this.flag == 2) {
        this.showNew = false;
        return "新建订单"
      } else if(this.flag == 3) {
        this.showNew = false;
        return ""
      } else {
        return "新建订单"
      }
    },
    hintDesc: function(){
      if(this.flag == 1){
        return "请输入姓名或账号搜索…"
      }else if(this.flag == 3){
        return "请输入姓名搜索…"
      } else {
        return "请输入订单ID或患者手机号查询…"
      }
    }
  },
  methods:{
    searchKeyword: function() {
      this.$emit('getSearch',this.search);
    },
    buildNewOrder: function(){
      this.showModal = true;
      this.$emit('getshowModel',this.showModal);
    },
    toTrain:function(){
      /* this.$router.push(); */
    }
  }
}
</script>

<style >
.appbarTitle{
  height: 100px !important;
}
.bgClass{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff !important;
}
.input-wrapper{
  position: relative;
  display: inline-block;
  margin-top:20px;
  width: 230px;
  height: 56px;
  line-height: 50px;
  padding-left: 40px;
}
.input-style{
  position: absolute!important;
  left: 0px;
  width: 250px!important;
  height: 40px!important;
  background-color: rgba(222,222,222,0.3)!important;
  border-radius: 50px!important;
  padding-left: 8px!important;
}
.textField{
  font-size: 15px;
  padding-left: 5px;
}
.btnSearchClass{
  background-color: #1BBE9F !important;
  border-radius: 20px !important;
  color:#fff !important;
  font-size: 15px !important;
  font-family: _GB2312 KaiTi_GB2312 !important;
}
.btnNewbuild{
  border-radius: 20px !important;
  color:#fff !important;
  font-size: 15px !important;
  font-family: _GB2312 KaiTi_GB2312 !important;
}
.training-wrapper{
  position: absolute;
  top: 10px;
  right: 100px;
  width:240px;
  height: 104px;
  background-color: rgba(255, 255, 255, 0.95);
  border: 1px solid #EEEEEE;
  z-index:999;
}
.training-content{
  width:240px;
  height: 104px;
  padding: 10px;
}
.training-title{
  height:30px;
  line-height: 30px;
  color:#0A81E5;
  font-size: 14px;
  font-weight:600;
}
.training-name,.training-time{
  height:30px;
  line-height: 30px;
  color:black;
  font-size: 14px;
}
.icon-wrapper{
  position: absolute;
  top:28px;
  right: 0;
  width: 50px;
  height: 50px;
  cursor: pointer;
}
.toTrain-icon{
  position: absolute;
  color:#0A81E5;
}

</style>



// WEBPACK FOOTER //
// searchBar.vue?2dbc85ee